import {createNavItem, ODCommonMainLayout, ODIcons, ODSiteNav} from '@mdpp/od-react-belt'
import * as React from 'react'
import {SiteUrls} from '../SiteUrls'
import {COLORS} from '../styles/colors'
import {HanmiManagerRoutes} from './HanmiManagerRoutes'
import {getHanmiManagerSiteNavs} from './HanmiManagerSiteNavs'
import {HanmiManagerHeader} from './gnb/HanmiManagerHeader'
import {useHanmiManagerAppContext} from './context/HanmiManagerAppContext'

export const HanmiManagerMainLayout: React.FC = () => {
  const initNavi = {
    items: [
      createNavItem(ODIcons.Dashboard, `대시보드`, SiteUrls.HanmiManager.Dashboard.Main),
    ],
  }

  const [naviList, setNaviList] = React.useState<ODSiteNav>()
  const [naviRendering, setNaviRendering] = React.useState(false)
  const { sideBarState } = useHanmiManagerAppContext()

  const renderInitNaviSideBar = () => {
    return (
      <ODCommonMainLayout
        renderHeader={() => <HanmiManagerHeader />}
        defaultRoute={SiteUrls.HanmiManager.Dashboard.Main}
        navs={initNavi}
        routes={HanmiManagerRoutes}
        style={{
          padding: 0,
          marginLeft: 0,
          marginTop: 0,
          marginBottom: 0,
          marginRight: 0,
          background: COLORS.GRAY100,
        }}
      />
    )
  }

  React.useEffect(() => {
    setNaviRendering(true)
    setTimeout(() => {
      try {
        setNaviList(getHanmiManagerSiteNavs())
        setNaviRendering(false)
      } catch (e) {
        setNaviRendering(false)
      }
    }, 100)
  }, [sideBarState])

  return (
    <>
      {naviRendering && renderInitNaviSideBar()}
    </>
  )
}
